var plugin_rtlignore_default = {
  "alignLeft": "RI5co",
  "textWrapNowrap": "VAo3Q",
  "alignRight": "_2BE7m",
  "alignCenter": "-Zu58",
  "sizeFullWidth": "gyCDO",
  "renderedInTable": "sT90m",
  "sizeOriginal": "yjEQQ",
  "sizeContent": "T998g",
  "sizeSmall": "aKL5X",
  "sizeSmallCenter": "_4108c",
  "flex": "_7AEfP",
  "atomic": "_2gdJs",
  "embed": "mIhgY",
  "horizontalScrollbar": "p-1eh",
  "pluginContainerMobile": "_0ywNC"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
